export default "__VITE_ASSET__Beq_c5Ac__"